var _class, _temp;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import t from 'prop-types';
import EditorTexto from '../editor/components/editor-texto';
import TextoFlotante from './texto-flotante';
var TextoEditable = (_temp = _class = function (_Component) {
  _inherits(TextoEditable, _Component);

  function TextoEditable(props) {
    _classCallCheck(this, TextoEditable);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleActivarEdicion = function () {
      if (!_this.props.activo) {
        return;
      }

      _this.setState({
        modoEdicion: true
      });
    };

    _this.handleCancelarEdicion = function () {
      var onCancelar = _this.props.onCancelar;

      _this.setState({
        modoEdicion: false
      }, function () {
        onCancelar && onCancelar();
      });
    };

    _this.handleModificar = function (textoHtml) {
      var textoId = _this.props.texto.id;
      var valores = {
        textoHtml: textoHtml
      };

      _this.setState({
        modoEdicion: false,
        textoHtml: textoHtml
      }, function () {
        return _this.props.onActualizar(textoId, valores);
      });
    };

    _this.handleMover = function (x, y) {
      var textoId = _this.props.texto.id;
      var valores = {
        x: x,
        y: y
      };

      _this.setState(valores, function () {
        return _this.props.onActualizar(textoId, valores);
      });
    };

    _this.state = {
      modoEdicion: props.modoEdicion,
      x: props.texto.x,
      y: props.texto.y,
      textoHtml: props.texto.textoHtml
    };
    return _this;
  }

  TextoEditable.prototype.render = function render() {
    var _props = this.props,
        offset = _props.offset,
        tamFuenteBase = _props.tamFuenteBase,
        config = _props.config;
    var _state = this.state,
        x = _state.x,
        y = _state.y,
        textoHtml = _state.textoHtml;

    if (this.state.modoEdicion) {
      return React.createElement(EditorTexto, {
        offset: offset,
        tamFuenteBase: tamFuenteBase,
        x: x,
        y: y,
        textoHtml: textoHtml === config.textoAyuda ? '' : textoHtml,
        textoAyuda: config.textoAyuda,
        onModificar: this.handleModificar,
        onCancelar: this.handleCancelarEdicion
      });
    }

    var _props2 = this.props,
        activo = _props2.activo,
        minX = _props2.minX,
        maxX = _props2.maxX;
    return React.createElement(TextoFlotante, {
      activo: activo,
      x: x,
      y: y,
      minX: minX,
      maxX: maxX,
      offset: offset,
      tamFuenteBase: tamFuenteBase,
      texto: textoHtml,
      onActivarEdicion: this.handleActivarEdicion,
      onMover: this.handleMover
    });
  };

  return TextoEditable;
}(Component), _class.defaultProps = {
  activo: true,
  modoEdicion: false,
  offset: {
    x: 0,
    y: 0
  },
  tamFuenteBase: 14
}, _temp);
TextoEditable.propTypes = process.env.NODE_ENV !== "production" ? {
  texto: t.shape({
    id: t.string.isRequired,
    x: t.number.isRequired,
    y: t.number.isRequired,
    textoHtml: t.string.isRequired
  }).isRequired,

  /** offset que se suma a las coordenadas para renderizar el componente. Opcional */
  offset: t.shape({
    x: t.number.isRequired,
    y: t.number.isRequired
  }),

  /** tamaño 'normal' de la fuente en pixels. 1em será tratado como de este tamaño. */
  tamFuenteBase: t.number,

  /** config de herramientas */
  config: t.object.isRequired,

  /** si activo === false, el texto no podra moverse ni modificarse **/
  activo: t.bool,
  minX: t.number,
  maxX: t.number,

  /** true, para pintarlo inicialmente en modo edicion */
  modoEdicion: t.bool,

  /** 
   * Evento que lanza el componente para informar de los nuevos valores del texto
   * Debe ser una fución con la forma: (textoId, valores) => {...} 
   * 
   * */
  onActualizar: t.func.isRequired,

  /**
   * Evento que se lanza cuando se pincha en cerrar el texto
   */
  onCancelar: t.func
} : {};
export default TextoEditable;